import { ArticleBase } from '../article/article.component';
import { Component, OnInit } from '@angular/core';
import { escape } from 'querystring';

@Component({
  selector: 'app-article-content13',
  templateUrl: './article-content13.component.html',
  styleUrls: ['./article-content13.component.css']
})
export class ArticleContent13Component implements OnInit {

  articleThirteen : ArticleBase;

  constructor() { }

  ngOnInit() {
    this.articleThirteen = { 'title' : '##',
                        'lastUpdated' : 'December 8 2022' };
  }

}
